import { AsyncPipe, NgClass, NgIf } from "@angular/common";
import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { UmbracoLinkComponent } from "../../../../common-components/umbraco-link/umbraco-link.component";
import { DeliveryApiService } from "../../../../shared-library/delivery-api/delivery-api.service";
import { LinkModel } from "../../../../shared-library/delivery-api/models/link.model";
import { PublishedContentModel } from "../../../../shared-library/delivery-api/models/published-content.model";
import { ExternalConfigurationService } from "../../../../shared-library/services/configuration/external-configuration.service";
import { UrlUtils } from "../../../../shared-library/utils/url.utils";
import { SavedSearchModel } from "../saved-search.model";
import { SavedSearchesService } from "../saved-searches.service";

@Component({
    selector: "pcg-ng-saved-searches-bar",
    templateUrl: "saved-searches-bar.component.html",
    imports: [
        NgIf,
        AsyncPipe,
        FormsModule,
        UmbracoLinkComponent,
        NgClass
    ],
    standalone: true
})
export class SavedSearchesBarComponent implements OnInit {
    public isSearchPage = false;
    public showForm = false;
    public formValue: SavedSearchModel;

    @Input() public savedSearchesPageLink: Array<LinkModel> = [];

    public constructor(
        public savedSearchesService: SavedSearchesService,
        public deliveryApiService: DeliveryApiService,
        private configurationService: ExternalConfigurationService<{ path: string, }>,
        private domElement: ElementRef
    ) {
    }

    public ngOnInit(): void {
        this.configurationService.initialize(this.domElement);

        this.savedSearchesService.savedSearches$.subscribe((savedSearches) => {
            this.formValue = savedSearches.find(s => UrlUtils.normalizeUrl(s.url) === UrlUtils.normalizeUrl(window.location.href)) || { id: "", name: "", description: "", url: UrlUtils.normalizeUrl(window.location.href) };
        });

        this.deliveryApiService.getPage$<PublishedContentModel>(this.configurationService.config?.path ?? window.location.pathname)
            .subscribe((page) => {
                this.isSearchPage = page.contentType === "DirectorySearchPage" || page.contentType === "ContentSearchPage";
            });
    }

    public toggleForm(event: Event): void {
        event.preventDefault();

        this.showForm = !this.showForm;
    }

    public save(event: Event): void {
        event.preventDefault();

        this.formValue.url = UrlUtils.normalizeUrl(window.location.href);
        if (this.formValue.id) {
            this.savedSearchesService.update(this.formValue);
        } else {
            this.savedSearchesService.create(this.formValue);
        }

        this.showForm = false;
    }

    public delete(event: Event): void {
        event.preventDefault();

        if (this.formValue.id) {
            this.savedSearchesService.delete(this.formValue);
        }

        this.showForm = false;
    }
}
